import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'

import '@/filters/filters'
import { i18n } from './i18n';
import { Config, ExternalSettings } from './utils/Config';
import './vee-validate';

declare var sodraAppEnv: any;

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'development') {
  const externalSettings: ExternalSettings = {
    BaseUrl: process.env.VUE_APP_DEV_BASE_URL,
    PageUrl: process.env.VUE_APP_DEV_PAGE_URL,
    GoBackUrl: process.env.VUE_APP_DEV_GOBACK_URL
  };
  
  Config.setSettings(externalSettings)
    .then(() => {

      new Vue({
        i18n,
        render: h => h(App)
      }).$mount('#app')
      
  });

}
else {

  // Register the library at sodra.com:
  sodraAppEnv.v1.registerLib('member_application', {
    MemberApplication(elem: any, appContext: any) {
      
      Config.setSettings(appContext.CustomValues)
        .then(() => {

          new Vue({
            i18n,
            render: h => h(App)
          }).$mount(elem)
      
      });

    }
  });
}